import { grunndataReducer } from './grunndata'
import { fylkesresultatReducer } from './fylkesresultat'
import { kommuneresultatReducer } from './kommuneresultat'
import { pageReducer } from './page'
import { AppAction } from '../actions'
import { AppState } from '../state'
import { PageAction } from '../actions/page'
import { GrunndataAction } from '../actions/grunndata'
import { FylkesresultatAction } from '../actions/fylkesresultat'
import { KommuneresultatAction } from '../actions/kommuneresultat'

// export const rootReducer = combineReducers({
//   page: pageReducer,
//   grunndata: grunndataReducer,
//   fylkesresultat: fylkesresultatReducer,
//   kommuneresultat: kommuneresultatReducer
// })

export function rootReducer(state: AppState, action: AppAction) {
  return {
    page: pageReducer(state.page, action as PageAction),
    grunndata: grunndataReducer(state.grunndata, action as GrunndataAction),
    fylkesresultat: fylkesresultatReducer(
      state.fylkesresultat,
      action as FylkesresultatAction,
      state.page
    ),
    kommuneresultat: kommuneresultatReducer(
      state.kommuneresultat,
      action as KommuneresultatAction,
      state.page
    )
  }
}
